module.exports = __webpack_public_path__ + "static/media/Diglo_banner_vertical.17d59e44.png";